import { Base64Decoder } from '@/for-actionscript/base64Decoder';
import { DebugHelper } from './debugHelper';

// 旧版データとの互換のためのヘルパークラス
export class CompatibleHelper
{
    static readonly BACK_LAYER_ID = "backlayer";

    // XMLの改行エスケープ文字を除いた文字列を返す
    public static removeXmlEscape(xml : string)
    {
        return xml.replace(/&#x0A;/g, '').replace(/&#xA;/g, '');
    }

    // エンコードテキストをARGBのバイト配列にする
    public static convertEncodedImageToARGBByteArray(encoded : string)
    {
        var decoder = new Base64Decoder();
        decoder.decode(encoded);
        return decoder.toByteArray();
    }

    // エンコードテキストをSVGデータにする
    public static convertCompressedEncodedImageToSvg(encoded : string)
    {
        var decoder = new Base64Decoder();
        decoder.decode(encoded);
        var array = decoder.toByteArray();
        let resZlib = this.decompressByteArrayByZlib(array);
        if(resZlib != null) {
            // -> SVG Tag
            return this.utf8_bytes_to_string(resZlib);
        }
        let resPako = this.decompressByteArrayByPako(array);
        if(resPako != null) {
            // -> SVG TAg
            return new TextDecoder().decode(resPako);
        }
        // -> SVG Tag
        return this.utf8_bytes_to_string(array);
    }

    // backlayer というidのgタグを削除する
    public static removeBacklayerFromSvg(tag : string)
    {
        var search = this.BACK_LAYER_ID;
        
        // まずタグからこのidの最初のポジションを得る。
        var blIndex = tag.indexOf(search);
        if(blIndex < 0) { return tag; }

        // このタグより前の文字列
        var before = tag.substr(0, blIndex);
        // このタグより後の文字列
        var after = tag.substring(blIndex + search.length, tag.length);

        // beforeを逆順にgタグを見つける
        var indexOfBeforeG = before.lastIndexOf("<g");
        // afterを順にタグ閉じを見つける
        var indexOfAfterG = after.indexOf("/g>");
        if(indexOfBeforeG < 0 || indexOfAfterG < 0) { return tag; }

        // beforeをgタグの直前まででカット
        var fixBefore = before.substring(0, indexOfBeforeG - 1);
        // afterをgタグ閉じの直後から得る
        var fixAfter = after.substring(indexOfAfterG + 3, after.length);

        // 文字列を戻す
        var fix = fixBefore + fixAfter;
        return fix;
    }

    // 圧縮エンコードテキストをARGBのバイト配列にする
    public static convertCompressedEncodedImageToARGBByteArray(compressedEncoded : string)
    {
        // デコードして圧縮配列にする
        var compressedArray = this.convertEncodedImageToARGBByteArray(compressedEncoded);
        let resZlib = this.decompressByteArrayByZlib(compressedArray);
        if(resZlib != null) {
            return resZlib;
        }
        let resPako = this.decompressByteArrayByPako(compressedArray);
        if(resPako != null) {
            return resPako;
        }
        return compressedArray;
    }

    // Zlibを使用したバイト配列の伸長
    public static decompressByteArrayByZlib(byteArray : Array<number>) : Array<number> | null
    {
        let res : Array<number> | null = null;
        try
        {
            let Inflate = require('zlibjs/bin/zlib.min').Zlib.Inflate;
            let inflate = new Inflate(byteArray);
            res = inflate.decompress();
        }
        catch(e)
        {
            DebugHelper.trace("decompressByteArrayByZlib error:");
            DebugHelper.trace(e);
        }
        return res;
    }

    // Pakoを使用したバイト配列の伸長
    // https://github.com/nodeca/pako
    public static decompressByteArrayByPako(byteArray : Array<number>) : Uint8Array | null
    {
        let res : Uint8Array | null = null;
        try
        {
            const pako = require('pako');
            let u8array = new Uint8Array(byteArray);
            res = pako.inflate(u8array);
        }
        catch(e)
        {
            DebugHelper.trace("decompressByteArrayByPako error:");
            DebugHelper.trace(e);
        }
        return res;
    }

    // UTF8バイト配列 -> 文字列
    private static utf8_bytes_to_string(arr)
    {
        if (arr == null)
            return null;
        var result = "";
        var i;
        while (i = arr.shift()) {
            if (i <= 0x7f) {
                result += String.fromCharCode(i);
            } else if (i <= 0xdf) {
                var c = ((i&0x1f)<<6);
                c += arr.shift()&0x3f;
                result += String.fromCharCode(c);
            } else if (i <= 0xe0) {
                var c = ((arr.shift()&0x1f)<<6)|0x0800;
                c += arr.shift()&0x3f;
                result += String.fromCharCode(c);
            } else {
                var c = ((i&0x0f)<<12);
                c += (arr.shift()&0x3f)<<6;
                c += arr.shift() & 0x3f;
                result += String.fromCharCode(c);
            }
        }
        return result;
    }
}